import { render, staticRenderFns } from "./contas-receber.vue?vue&type=template&id=53c06697&scoped=true"
import script from "./contas-receber.vue?vue&type=script&lang=js"
export * from "./contas-receber.vue?vue&type=script&lang=js"
import style0 from "./contas-receber.vue?vue&type=style&index=0&id=53c06697&prod&scoped=true&lang=css"
import style1 from "./contas-receber.vue?vue&type=style&index=1&id=53c06697&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c06697",
  null
  
)

export default component.exports